import { render, staticRenderFns } from "./settingModal.vue?vue&type=template&id=36865326&"
import script from "./settingModal.vue?vue&type=script&lang=js&"
export * from "./settingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports